import * as Html from "../../util/Html.ts";
import Icons from "../../svg/Icons.ts";

Html.registerWidget('widget/form/checkbox-master',{initDom:initDom})

function initDom(elem: HTMLElement){
  elem.style.cursor = 'pointer';

  const icon = elem.querySelector("icon") as HTMLElement;
  if(!icon) return;

  const parent = elem.parentElement;
  if(!parent) return;

  const subcheckboxes = parent.querySelectorAll<HTMLInputElement>('input[type="checkbox"]');

  function isAllChecked(): boolean {
    return Array.from(subcheckboxes).every(cb => cb.checked);
  }

  let checked = isAllChecked();

  function refreshDisplay(){
    icon.innerHTML = checked ? Icons.ic_checked.toString() : Icons.ic_checkbox.toString();
  }

  elem.addEventListener('click', function(event){
    const target = event.target as HTMLElement;
    if(target.closest('[data-fw-onclick]')) {
      return;
    }
    checked = !checked;
    refreshDisplay();
    subcheckboxes.forEach(subcheckbox => {
      subcheckbox.checked = checked;
      subcheckbox.dispatchEvent(new Event('blur'));
    });
  }, false);

  refreshDisplay();
}
